import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {IUrlParams} from '../../services/RedirectionService';
import {resolveUserAndAccount} from '../helper/auth-resolve.helper';
import {IHistoryConsoleStore, HistoryConsoleStore} from './history-console.stores';
import {IBrowserUtilsService} from '@techsee/techsee-client-infra/lib/services/BrowserUtilsService';
import {UriUtils} from '../../utils/utils';

const trace = getAppTracer('history-console.loader');
function getUrlParamsFromRequest(tsBrowserUtils: IBrowserUtilsService): IUrlParams {
    return {
        customerRef: tsBrowserUtils.getParamValue('r') || undefined,
        customerPhone: tsBrowserUtils.getParamValue('p') || undefined,
        customerEmail: UriUtils.safeDecode(tsBrowserUtils.getParamValue('e')),
        startDate: tsBrowserUtils.getParamValue('startDate') || undefined,
        endDate: tsBrowserUtils.getParamValue('endDate') || undefined,
        roomId: tsBrowserUtils.getParamValue('roomId') || undefined,
        scanId: tsBrowserUtils.getParamValue('scanId') || undefined,
        preDataCollectionCode: tsBrowserUtils.getParamValue('preDataCollectionCode') || undefined
    };
}

export async function historyConsoleRouteLoader(args: LoaderFunctionArgs): Promise<IHistoryConsoleStore | void> {
    trace.info('Starting');
    const rootStore = getRootStore();

    await rootStore.initRootServicesCompleted;

    const {accountData, currentUser} = await resolveUserAndAccount();

    const urlParams = getUrlParamsFromRequest(rootStore.browserUtilsService);
    const store = new HistoryConsoleStore(accountData, urlParams, currentUser);

    trace.info('Completed successfully');
    return store;
}
